import { defineComponent as t, Types as e } from "bitecs";
var i = /* @__PURE__ */ ((f) => (f[f.Dynamic = 0] = "Dynamic", f[f.Fixed = 1] = "Fixed", f[f.KinematicPositionBased = 2] = "KinematicPositionBased", f[f.KinematicVelocityBased = 3] = "KinematicVelocityBased", f))(i || {}), s = /* @__PURE__ */ ((f) => (f[f.Box = 0] = "Box", f[f.Sphere = 1] = "Sphere", f[f.Capsule = 2] = "Capsule", f))(s || {});
const a = t({
  gravityX: e.f32,
  gravityY: e.f32,
  gravityZ: e.f32
}), c = t({
  type: e.ui8,
  mass: e.f32,
  linearDamping: e.f32,
  angularDamping: e.f32,
  gravityScale: e.f32,
  ccd: e.ui8,
  lockRotX: e.ui8,
  lockRotY: e.ui8,
  lockRotZ: e.ui8,
  posX: e.f32,
  posY: e.f32,
  posZ: e.f32,
  rotX: e.f32,
  rotY: e.f32,
  rotZ: e.f32,
  rotW: e.f32,
  eulerX: e.f32,
  eulerY: e.f32,
  eulerZ: e.f32,
  velX: e.f32,
  velY: e.f32,
  velZ: e.f32,
  rotVelX: e.f32,
  rotVelY: e.f32,
  rotVelZ: e.f32
}), l = t({
  shape: e.ui8,
  sizeX: e.f32,
  sizeY: e.f32,
  sizeZ: e.f32,
  radius: e.f32,
  height: e.f32,
  friction: e.f32,
  restitution: e.f32,
  density: e.f32,
  isSensor: e.ui8,
  membershipGroups: e.ui16,
  filterGroups: e.ui16,
  posOffsetX: e.f32,
  posOffsetY: e.f32,
  posOffsetZ: e.f32,
  rotOffsetX: e.f32,
  rotOffsetY: e.f32,
  rotOffsetZ: e.f32,
  rotOffsetW: e.f32
}), u = t({
  offset: e.f32,
  maxSlope: e.f32,
  maxSlide: e.f32,
  snapDist: e.f32,
  autoStep: e.ui8,
  maxStepHeight: e.f32,
  minStepWidth: e.f32,
  upX: e.f32,
  upY: e.f32,
  upZ: e.f32,
  moveX: e.f32,
  moveY: e.f32,
  moveZ: e.f32,
  grounded: e.ui8,
  platform: e.eid,
  platformVelX: e.f32,
  platformVelY: e.f32,
  platformVelZ: e.f32
}), p = t({
  desiredVelX: e.f32,
  desiredVelY: e.f32,
  desiredVelZ: e.f32,
  velocityY: e.f32,
  actualMoveX: e.f32,
  actualMoveY: e.f32,
  actualMoveZ: e.f32
}), m = t({
  prevPosX: e.f32,
  prevPosY: e.f32,
  prevPosZ: e.f32,
  prevRotX: e.f32,
  prevRotY: e.f32,
  prevRotZ: e.f32,
  prevRotW: e.f32,
  posX: e.f32,
  posY: e.f32,
  posZ: e.f32,
  rotX: e.f32,
  rotY: e.f32,
  rotZ: e.f32,
  rotW: e.f32
}), v = t({
  activeEvents: e.ui8
}), d = t({
  other: e.ui32,
  handle1: e.ui32,
  handle2: e.ui32
}), Y = t({
  other: e.ui32,
  handle1: e.ui32,
  handle2: e.ui32
}), o = { x: e.f32, y: e.f32, z: e.f32 }, r = {
  x: e.f32,
  y: e.f32,
  z: e.f32,
  w: e.f32
}, X = t(o), Z = t(o), h = t(o), V = t(o), g = t(o), x = t(o), y = t(o), R = t(r), A = t(o);
export {
  V as ApplyAngularImpulse,
  X as ApplyForce,
  h as ApplyImpulse,
  Z as ApplyTorque,
  c as Body,
  i as BodyType,
  u as CharacterController,
  p as CharacterMovement,
  l as Collider,
  s as ColliderShape,
  v as CollisionEvents,
  m as InterpolatedTransform,
  A as KinematicAngularVelocity,
  y as KinematicMove,
  R as KinematicRotate,
  a as PhysicsWorld,
  x as SetAngularVelocity,
  g as SetLinearVelocity,
  Y as TouchEndedEvent,
  d as TouchedEvent
};
//# sourceMappingURL=components.js.map
